// frontend_react/src/components/Navbar.jsx

import { useState, useEffect, useRef } from 'react';
import { useLogin } from "../context/LoginContext";
import crownLogo from '../assets/queens_logo.svg';
import homeIcon from '../assets/home.svg';
import cartIcon from '../assets/cart.svg';
import storeIcon from '../assets/store.svg';
import salesIcon from '../assets/sales.svg';
import calendarIcon from '../assets/calendar.svg';
import settingsIcon from '../assets/settings.svg';
import profilePic from '../assets/profile_picture.jpg';
import '../styles/navbar.css';

// On importe useLocation pour détecter les changements de page
import { NavLink, Link, useLocation } from 'react-router-dom';

function Navbar() {
  // --- 1. Logique de Visibilité (Ton code intégré) ---
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();
  const lastTouchY = useRef(0);
  const { user } = useLogin();

  // Reset la barre visible à chaque changement de page
  useEffect(() => {
    setIsVisible(true);
  }, [location]);

  useEffect(() => {
    // A. GESTION SOURIS (Molette)
    const handleWheel = (e) => {
      if (e.deltaY > 0) {
        setIsVisible(false); // On descend -> Cacher
      } else if (e.deltaY < 0) {
        setIsVisible(true);  // On monte -> Afficher
      }
    };

    // B. GESTION TACTILE (Doigt)
    const handleTouchStart = (e) => {
      lastTouchY.current = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      const currentY = e.touches[0].clientY;
      const diff = lastTouchY.current - currentY;

      if (diff > 10) {
        setIsVisible(false); // Le doigt monte -> Cacher
      } else if (diff < -10) {
        setIsVisible(true);  // Le doigt descend -> Afficher
      }
      
      lastTouchY.current = currentY; 
    };

    // Ajout des écouteurs
    window.addEventListener('wheel', handleWheel);
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchmove', handleTouchMove);

    // Nettoyage (Le destructeur de notre composant 🧹)
    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);


  // --- 2. Logique de Navigation ---
  const getLinkClass = ({ isActive }) => {
      return isActive ? "navbar_active" : "navbar_hoverable";
  };

  return (
    <>
      {/* Ici, on ajoute une classe conditionnelle via template literals.
         Si isVisible est faux, on ajoute 'navbar_hidden'.
      */}
      <div className={`navbar ${isVisible ? '' : 'navbar_hidden'}`}>
        
        <Link to="/" target="_blank">
          <img src={crownLogo} className="store_logo white_svg" alt="Crown logo" />
        </Link>

        <NavLink to="/" className={getLinkClass} end>
          <img src={homeIcon} className="navbar_icons white_svg" alt="Home" />
          <p>Accueil</p>
        </NavLink>

        <NavLink to="/cart" className={getLinkClass}>
          <img src={cartIcon} className="navbar_icons white_svg" alt="Cart" />
          <p>Caisse</p>
        </NavLink>

        <NavLink to="/sales" className={getLinkClass}>
          <img src={salesIcon} className="navbar_icons white_svg" alt="Sales" />
          <p>Ventes</p>
        </NavLink>

        <NavLink to="/calendar" className={getLinkClass}>
          <img src={calendarIcon} className="navbar_icons white_svg" alt="Calendar" />
          <p>Calendrier</p>
        </NavLink>

        <NavLink to="/admin" className={getLinkClass}>
          <img src={settingsIcon} className="navbar_icons white_svg" alt="Settings" />
          <p>Paramètres</p>
        </NavLink>

        <NavLink to="/profil" className="align_bottom">
          <img
            src={user?.profile_picture_url || profilePic}
            className="navbar_profile_picture"
            alt="Profile"
          />
          <p>
            {user?.firstname ||
              user?.username ||
              "Profil"}
          </p>
        </NavLink>

      </div>
    </>
  )
}

export default Navbar